/// <reference path="./../Tag.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class Textarea extends Tag {
        public getText(): string {
            return this.getElement().value;
        }

        public clear(): this {
            this.getElement().value = "";
            return this;
        }

        public setText(value: any): void {
            this.getElement().value = value;
        }

        /**
         *
         * @returns {string}
         */
        public getTagName() {
            return "textarea";
        }

        protected createSelf() {
            super.createSelf();
            this.getElement().textContent = this.get("v");
        }
    }
}
